
export const GlobalUserInfoLocalStorageKey = 'Global_user_info_storage_key'